import { render, staticRenderFns } from "./cgl-pay-detail-info.vue?vue&type=template&id=2ee0189a&"
import script from "./cgl-pay-detail-info.vue?vue&type=script&lang=js&"
export * from "./cgl-pay-detail-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports